import { round } from "mathjs";
import { sorting_options } from "@liveflight/utilities/sorting";
import { get_markup } from "@liveflight/utilities/price";
import {
  flight_offer_total_duration,
  flight_offer_average_duration,
} from "@liveflight/utilities/flight-duration";

export function parse_flight_offer_for_ecommerce_item(flightOffer) {
  const { segments: first_itin_segments = [] } =
    flightOffer.itineraries[0] || {};
  const firstSegment = first_itin_segments[0] || {};
  const {
    carrier: first_carrier = {},
    departure: first_departure = {},
    aircraft: first_aircraft = {},
  } = firstSegment;
  const brand = `${flightOffer.source}-${first_carrier.code || ""}`;

  const itemName = flightOffer.itineraries
    .map((itinerary) => {
      return itinerary.segments
        .map((segment) => {
          return `${segment.departure.iataCode}${segment.arrival.iataCode}`;
        })
        .join("-");
    })
    .join("/");

  const price = flightOffer.price.grandTotal;

  const itemId = [
    first_departure.at || "",
    first_aircraft.code || "",
    firstSegment.flightNumber || "",
  ].join("|");

  return {
    item_id: itemId,
    item_name: itemName,
    item_brand: brand,
    price: price,
    item_category: "",
  };
}

export function parse_flight_offers(flightOffers) {
  const flights = flightOffers.data ? flightOffers.data : [];
  const dictionaries = flightOffers.dictionaries
    ? flightOffers.dictionaries
    : {};
  const meta = flightOffers.meta ? flightOffers.meta : {};
  let best_picks = {};
  if (flightOffers.bestFlight && flightOffers.bestFlight.benchmarks) {
    Object.keys(sorting_options).forEach((sorting) => {
      let flight_offer_id = flightOffers.bestFlight.bestOfferId;
      if (sorting === "price") {
        flight_offer_id = flightOffers.bestFlight.benchmarks.bestPriceId;
      }
      if (sorting === "duration") {
        flight_offer_id = flightOffers.bestFlight.benchmarks.bestDurationId;
      }

      const flight_offer = flights.find(
        (f) => f.id === String(flight_offer_id),
      );
      if (flight_offer) {
        best_picks[sorting] = {
          total_duration: flight_offer_total_duration(flight_offer),
          duration: flight_offer_average_duration(flight_offer),
          flight_offer_id: String(flight_offer_id),
          rankings: flightOffers.bestFlight.metadata || {},
          price: {
            ...flight_offer.price,
            ...get_markup(flight_offer),
          },
        };
      }
    });
  }
  return {
    best_picks,
    flights: flights,
    //offers: offersSorted,
    dictionaries: dictionaries,
    meta: meta,
  };
}

export function parse_flight_offers_classes(flight_offer) {
  let classes_by_segment = {
    //segment_id: [classe_pax_1, classe_pax_2, ...]
  };

  let cabins = {
    ECONOMY: "Economy",
    PREMIUM_ECONOMY: "Premium economy",
    BUSINESS: "Business",
    FIRST: "First",
  };

  // in caso di schedule changes possono mancare i fareDetailsBySegment dei segmenti modificati
  // quindi preparo classes_by_segment popolando con gli id dei segmenti che trovo negli itinerari
  // così se manca un fareDetailsBySegment non si pianta il rendering
  flight_offer.itineraries.forEach((it) => {
    it.segments.forEach((seg) => {
      classes_by_segment[seg.id] = [];
    });
  });

  flight_offer.travelerPricings.forEach((t) => {
    if (t.fareDetailsBySegment) {
      t.fareDetailsBySegment.forEach((f) => {
        if (!classes_by_segment[f.segmentId])
          classes_by_segment[f.segmentId] = [];
        if (f.cabin) {
          // "traduce" e pusha
          classes_by_segment[f.segmentId].push(
            cabins[f.cabin] ? cabins[f.cabin] : f.cabin,
          );

          // elimina duplicati
          classes_by_segment[f.segmentId] = classes_by_segment[
            f.segmentId
          ].filter((element, index) => {
            return classes_by_segment[f.segmentId].indexOf(element) === index;
          });
        }
      });
    }
  });

  return classes_by_segment;
}

export function formatPassengerName(passenger, fullName = false) {
  if (!passenger) return "";
  return [
    passenger.firstname,
    fullName ? passenger.middlename : undefined,
    passenger.lastname,
    fullName ? passenger.second_lastname : undefined,
  ]
    .filter((e) => !!e)
    .join(" ");
}

export function formatSegmentLabel(segmentInfo, fullDescription = false) {
  const { arrival, departure } = segmentInfo;
  if (!fullDescription) {
    return `${departure.iataCode} › ${arrival.iataCode}`;
  }
  return `${departure.airportName || departure.iataCode} › ${arrival.airportName || arrival.iataCode}`;
}

export const formatPrice = (price) => {
  const roundedPrice = String(round(price, 2));

  if (!roundedPrice.includes(".")) {
    return roundedPrice + ".00";
  }

  try {
    const decimals = roundedPrice.split(".")[1];
    return roundedPrice + (decimals.length === 1 ? "0" : "");
  } catch (e) {
    return roundedPrice;
  }
};

export const capitalize = (text = "") =>
  String(text).charAt(0).toUpperCase() + String(text).slice(1).toLowerCase();

const MONTHS = {
  0: "gennaio",
  1: "febbraio",
  2: "marzo",
  3: "aprile",
  4: "maggio",
  5: "giugno",
  6: "luglio",
  7: "agosto",
  8: "settembre",
  9: "ottobre",
  10: "novembre",
  11: "dicembre",
};

export const verbose_month = (month_index) => MONTHS[month_index] || "";

// replace(/ /g) instead of replaceAll — the jest runtime (.nvmrc → Node 14)
// predates String.replaceAll and core-js 2 has no polyfill for it.
export const as_compare_string = (v) =>
  String(v).toLowerCase().replace(/ /g, '');